/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { History } from "history";

import { Container } from "unstated";
import BasicLogic from "../Logic/Basic/basicLogic";
import basicLogic from "../Logic/Basic/index";

export interface AppStateModel {
  basicLogic: BasicLogic;
  appHistory: History;
}

export interface AppStateConstructorArgs {
  history: History;
}

export class AppState extends Container<AppStateModel> {
  constructor({ history }: AppStateConstructorArgs) {
    super();
    this.state = {
      appHistory: history,
      basicLogic,
    };
    // Register unstated based state manager to call setState on change
    [basicLogic].forEach((stateManager: Container<any>) => stateManager.subscribe(() => this.setState({})));
  }
}

export default function(constructorArgs: AppStateConstructorArgs) {
  return new AppState(constructorArgs);
}
